import { type FC } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { DropdownList } from '../../../Components/DropdownList/index.tsx';

interface PlaceholdersDropdownItemProps {
  item: string;
  onClick: (placeholder: string) => void;
}

export const PlaceholdersDropdownItem: FC<PlaceholdersDropdownItemProps> = ({ item, onClick }) => {
  const handleClick = useCallbackRef(() => {
    onClick(item);
  });

  return (
    <DropdownList.DropdownItem onClick={handleClick} dataTestId={`placeholder-${item}`}>
      {item}
    </DropdownList.DropdownItem>
  );
};
